import {numberLocale} from "../i18n/index.js";
// Small formatting helpers shared between the on-screen report preview
// (CrossSectionReportPanel.js) and the PDF export (CrossSectionPdfBuilder.js) -
// kept in one place so the two can never disagree on how a number or the
// generation timestamp reads. Pure/no DOM, Level 1 tested.

export function formatNumber(value, decimals){
	return value.toLocaleString(numberLocale(), {minimumFractionDigits: decimals, maximumFractionDigits: decimals});
}

// Task section 3: the report's own "Genereret: <dato> kl. <tid>" timestamp -
// this is the ONLY place a generation date/time appears anywhere in the
// output (no browser-added print date/time exists any more now that
// CrossSectionPdfBuilder.js builds the PDF directly, instead of via
// window.print()).
export function formatGeneratedAt(date = new Date()){
	return date.toLocaleString(numberLocale(), {dateStyle: "long", timeStyle: "short"});
}
